import dayjs from 'dayjs';
import * as React from 'react';
import { useIntl } from 'react-intl';
import TooltipComponent from '../../TooltipComponent';
import {
  ALARM_ID,
  END_TYPE,
  EVENT_ID,
  MIDNIGHT_ID,
  PARKING_TYPE,
  START_TYPE,
  WAYPOINT_ID,
} from '../constants';
import { getDay } from '../TripsOverviewService';

interface IEventTitleProps {
  index: number;
  text: string;
  duration: string | null;
  activatedAt: string | null;
  type: string;
}

function EventInTable(props: IEventTitleProps): JSX.Element {
  const { formatMessage: f } = useIntl();
  const [isLong, setIsLong] = React.useState<boolean | null>(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => {
    if (props.text) {
      const text = document.getElementById(`event-in-table-${props.index}`);
      if (text && !isLong && text.clientHeight > 18) {
        setIsLong(true);
      }
    }
  });

  const getTextColor = (type: string) => {
    let color = '';
    switch (type) {
      case START_TYPE:
        color = '';
        break;
      case PARKING_TYPE:
        color = '';
        break;
      case END_TYPE:
        color = '';
        break;
      case WAYPOINT_ID:
        color = '#128169';
        break;
      case ALARM_ID:
        color = '#b50536';
        break;
      case EVENT_ID:
        color = '#3d278f';
        break;
      case MIDNIGHT_ID:
        color = '#b7b7b7';
        break;
      default:
        color = '';
    }
    return color;
  };

  const getDuration = (): JSX.Element | null => {
    return props.duration && props.type !== START_TYPE && props.type !== END_TYPE ? (
      <span> ({props.duration})</span>
    ) : null;
  };

  const getElement = () => {
    return (
      <>
        {props.type === MIDNIGHT_ID ? (
          <span>
            {props.activatedAt
              ? dayjs(props.activatedAt).format('DD.MM.YYYY')
              : f({ id: 'tables.tripsOverview.column.datetime.anonymized' })}{' '}
            -{' '}
            {props.activatedAt
              ? f({
                  id: `date.${getDay(String(props.activatedAt))}`,
                })
              : ''}
          </span>
        ) : (
          props.text
        )}
        {getDuration()}
      </>
    );
  };

  return isLong ? (
    <td style={{ color: getTextColor(props.type) }} className="text-truncate-tooltip">
      <TooltipComponent
        id={`event-table-${props.index}`}
        overlay={
          // eslint-disable-next-line react/jsx-wrap-multilines
          <div style={{ color: '#fff' }}>
            {props.text} {getDuration()}
          </div>
        }
        width="270px"
        firstItems={props.index === 0}
        positionLeft
      >
        <div
          style={{
            whiteSpace: 'nowrap',
            width: '300px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
          }}
        >
          {getElement()}
        </div>
      </TooltipComponent>
    </td>
  ) : (
    <td style={{ color: getTextColor(props.type) }} className="text-truncate-tooltip">
      <div id={`event-in-table-${props.index}`}>{getElement()}</div>
    </td>
  );
}

export default EventInTable;
